module.exports = __webpack_public_path__ + "static/media/messages.959bfbbb.svg";